import { Action, createReducer, on } from '@ngrx/store';
import * as fromPreviousFactSheetActions from '../actions';

export const getPreviousFactsheetFeatureKey = 'getPreviousFactsheet';

export interface State {
  loaded: boolean;
  error?: Error | any;
  getPreviousFactSheet: any;
}

export const initialState: State = {
  loaded: false,
  error: undefined,
  getPreviousFactSheet: undefined
};

export const reducer = createReducer(
  initialState,
  on(
    fromPreviousFactSheetActions.loadGetPreviousFactsheets,

    state => state
  ),
  on(fromPreviousFactSheetActions.loadGetPreviousFactsheetsSuccess, (state, action) => ({
    ...state,
    getPreviousFactSheet: action.response,
    loaded: true
  })),

  on(fromPreviousFactSheetActions.loadGetPreviousFactsheetsFailure, (state, { error }) => ({
    ...state,
    error
  }))
);

export const selectPreviousFactSheets = (state: State) => state.getPreviousFactSheet;
export const selectPreviousFactSheetsLoaded = (state: State) => state.loaded;
export const selectPreviousFactSheetsError = (state: State) => state.error;
